<template>
  <div>
    <div class="container-fluid" id="category_wrap">
      <ForumList :category="this.$route.params.slug" />
    </div>
  </div>
</template>

<script>
import ForumList from '../../components/forum/ForumList.vue';

export default {
  name: "Categories",
  components:{
    ForumList
  },
  props: {
  },
  data() {
    return {
    }
  },
  computed:{
  },
  methods:{
  },
  mounted() {
  },
  watch: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
